import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsCustomObjectTypeAttributes = "/custom_objects/custom_object_type_attributes";

export const customObjectsCustomObjectTypeAttributesCacheKeys: AllRouteEndpoints[] = [
  "/custom_objects/custom_object_type_attributes",
];
